import { FC } from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";



const CustomComponentForTransfer: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {



  return (
    <div className="row">
      <div className="col-12">
        <div className="card mt-3">
          <div className="card-header">
            <h2 className="m-0 text-center text-primary">Transfers
            </h2>
          </div>
          <div className="card-body">
            <h1 className="text-center fw-bold">
              {StatisticsObjectType.transfer && StatisticsObjectType.transfer}%
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomComponentForTransfer;
